import { ImgProvider } from "assets/desktop/images/navSubgame";
import { ProviderLogo } from "assets/desktop/images/providerList";
import { SubGameType } from "types/game";

export const listFishing: SubGameType[] = [
  {
    game_code: "",
    name: "GR",
    provider_code: "GR",
    provider_name: "GR Fishing",
    type: "FH",
    featured: "",
    new_arrive: "",
    picture: ImgProvider.FishGR,
    icon: ProviderLogo.GR,
  },
  {
    game_code: "",
    name: "SP",
    provider_code: "SP",
    provider_name: "SP Fishing",
    type: "FH",
    featured: "",
    new_arrive: "",
    picture: ImgProvider.FishSP,
    icon: ProviderLogo.FishSP,
  },
];
